<template>
    <div class="container pb-4">

<div class="row py-4">
    <div class="col text-center">
        <a :href="`/dashboard/view/${order.id}`"><i class="fa-solid fa-arrow-left pr-1"></i>Back to order</a>
    </div>
</div>

  <div class="row">

    <div :class="firstClass">
        <div class="card mb-3">
        <div class="card-body">

          <div v-if="loading" class="text-center"><i class="fas fa-spinner fa-spin"></i></div>
          <div v-else>

            <div v-if="product">
              <div class="mb-3 text-center alert alert-success py-2" v-if="shippingInfo && shippingInfo.estimated_delivery">Estimated delivery {{formatDateSimple(shippingInfo.estimated_delivery)}}</div>
                <div class="pb-3 text-center">
                    <div v-if="product.images">
                      <a :href="makeProductLink(product)" target="_blank" title="View product">
                        <img v-if="product.images.length > 0" :src="product.images[0].url" style="height:4rem;">
                        <img v-else src="/images/image-not-found.svg" style="height:4rem;">
                      </a>
                    </div>
                    <div class="mt-2"><b>{{product.name}}</b></div>
                </div>   
            </div>

            <div v-if="loadingUpdates" class="text-center"><i class="fas fa-spinner fa-spin"></i></div>

            <div v-else-if="updates.length == 0" class="text-center">
                <div class="alert alert-warning py-1 mb-0"><i class="far fa-clock mr-2"></i>No shipping updates yet</div>
            </div>

            <table v-else class="table" style="line-height:1.3rem;">
                <thead class="thead-dark">
                <tr>
                  <th class="first-left pl-3">Status</th>
                  <th class="first-right pl-3">Updated</th>
                </tr>
              </thead>
                <tbody>
                    <tr v-for="(update, index) in updates" :key="index">
                        <td class="pl-3">{{formatName(update.status.name)}}</td>
                        <td class="pl-3"><timeago
                        :datetime="update.created_at"
                        :auto-update="60"
                        :title="formatDateMoment(update.created_at)"></timeago>
                        </td>
                    </tr>
                </tbody>
                </table>

        </div>
        </div>
        </div>
    </div>

    <div v-if="firstUpdate == 'Delivered'" class="col-md-3 text-center">
        <div class="card">
        <div class="card-body">
          <div><a href="#/" @click="showModalReturnProduct()"><i class="fas fa-undo mr-2"></i>Return product</a></div>
        </div>
        </div>
    </div>

    </div>
<return-product-modal ref="ReturnProductModal" @return-product="returnProduct" :orderProductId="order_product_id"></return-product-modal>
</div>

</template> 

<script>


export default {
 props: ['order_id','order_product_id', 'product_id'],
  data() {
    return {
      order: {},
      product: {},
      updates: [],
      loading: false,
      firstUpdate: null,
      loadingUpdates: false,
      shippingInfo: null
    };
  },

  computed: {
    firstClass() {
      return this.firstUpdate == 'Delivered' ? 'col-md-9 pr-md-0' : 'col';
    }
  },

  created() {
    this.getOrder();
    this.getUpdates();
    this.getProduct();
    this.getShippingInfo();
  },

  methods: {

    showModalReturnProduct() {
      this.$refs.ReturnProductModal.clearInfo();
      this.$bvModal.show('bv-modal-return-product');
    },

    getProduct() {
      this.loading = true;
      axios
        .get('/product/get/'+this.product_id)
        .then((response) => {
          this.product = response.data;
          this.loading = false;
        });
    },

    getShippingInfo() {
      axios
        .get('/dashboard/shipping-info/'+this.order_product_id)
        .then((response) => {
          this.shippingInfo = response.data;
        });
    },

    returnProduct() {
      window.location.href = '/returns/confirmation';
    },

    getOrder() {
      axios.get('/dashboard/get/' + this.order_id).
      then((response) => {
        this.order = response.data.order;
        this.loading = false;
      });
    },

    getUpdates() {

      this.loadingUpdates = true;

      axios.get(`/dashboard/${this.order_product_id}/updates`).
      then((response) => {
        this.updates = response.data;

        if (this.updates.length > 0) {
          this.firstUpdate = this.formatName(this.updates[0].status.name);
        }

        this.loadingUpdates = false;
      });
    },

  },
};
</script>